<script>
  import store from '@shared/store'
  import axios from '@shared/module/axios'
  import Auth from '@aws-amplify/auth'
  import pushNotificationSettings from '@shared/push-notification-settings'
  import settings from '@shared/settings'

  export default {
    methods: {
      changeLocaleInUserPool(language) {
        Auth.currentAuthenticatedUser().then(user => {
          Auth.updateUserAttributes(user, { locale: language })
        })
      },
      signInRequest(pin) {
        const payload = {
          pin,
          deviceToken: pushNotificationSettings.deviceToken(),
          devicePlatform: settings.devicePlatform()
        }
        return axios.post('/api/authentication/sign-in', payload)
      },
      logOut() {
        const payload = {
          deviceToken: pushNotificationSettings.deviceToken(),
          devicePlatform: settings.devicePlatform()
        }
        axios.post('/api/authentication/sign-out', payload).finally(() => {
          Auth.signOut()
          store.logOut()
          this.$router.push({ name: 'home' })
        })
      },
      getAndStoreCustomerProfile(pin) {
        if (settings.featureFlags.isMastercardWithdrawalEnabled()) {
          axios.get(`/api/customers/${pin}/cards`).then(response => {
            store.setCustomerCards(response.data.cards)
            if (response.data.error) {
              console.error('Failed to load cards', response.data.error)
            }
          })
        }
        return axios.get(`/api/customers/${pin}/profile`).then(response => {
          store.setCurrentUser(response.data)
        })
      },
      redirectToCustomerOverview(pin) {
        this.$router.replace({ name: 'no-back', params: { page: 'customer-overview' } })
        store.promoteBiometricLogin(pin)
      }
    }
  }
</script>
